import { ChangeDetectorRef, Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { RouterLink } from '@angular/router';
import { finalize } from 'rxjs';

import { resetHubspotCookiesAndReloadPage } from '../../../../../../lib/hubspot';
import { AuthService } from '../../../../../auth/auth.service';
import { CompanyShort } from '../../../../../models/company';
import { ID } from '../../../../../models/id';
import { User } from '../../../../../models/user';
import { WINDOW } from '../../../../window/window.token';

@Component({
  selector: 'app-header-account-panel',
  templateUrl: './header-account-panel.component.html',
  styleUrls: ['./header-account-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatOptionModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    RouterLink,
  ],
})
export class HeaderAccountPanelComponent implements OnInit {
  private authService = inject(AuthService);
  private window = inject<Window>(WINDOW);
  private cdr = inject(ChangeDetectorRef);

  @Input() user: User;
  companyLoading: boolean;
  companies: CompanyShort[];
  companiesControl: UntypedFormControl = new UntypedFormControl('');

  ngOnInit(): void {
    this.authService.getUserCompanies().subscribe((companies: CompanyShort[]): void => {
      this.companies = companies;
      this.companiesControl.setValue(this.user.company_id);
      this.cdr.markForCheck();
    });
  }

  logout(): void {
    this.authService.logout().subscribe(() => {
      resetHubspotCookiesAndReloadPage();
    });
  }

  selectCompany(id: ID): void {
    this.companyLoading = true;
    this.authService
      .selectCompany(id)
      .pipe(
        finalize(() => {
          this.companyLoading = false;
        }),
      )
      .subscribe(() => {
        this.window.location.reload();
        this.authService.redirectToHomePage(this.user);
      });
  }
}
